import script from "./MapLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapLegend.vue?vue&type=script&setup=true&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=b56cfb3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b56cfb3e"]])

export default __exports__